import './App.css';

function App()
{
  function close()
  {
    let closed = document.querySelector("#popup");
    closed.style.display = "none"
    console.log("Popup closed!")
  }
  function open()
  {
    let closed = document.querySelector("#popup");
    closed.style.margin = "auto"
    closed.style.display = "block"
    console.log("Popup Opend!")
  }
  return (
    <>
      <section class="animated-background">
        <div id="stars1"></div>
        <div id="stars2"></div>
        <div id="stars3"></div>
      </section>
      <a id="profilePicture" href="#popup" onClick={open}>
        <img src="./logo.jpeg" alt="Profile Picture" />
      </a>

      <div class="overlay" id="popup">
        <div class="popup">
          <div class="popup-photo">
            <a href="./logo.jpeg" target="_blank" rel="noreferrer">
              <img src="./logo.jpeg" alt="Profile Picture" />
            </a>
          </div>
          <div class="popup-quote">
            Hey Visitors,I 'm Prabhat. You might recognize me as MERN Stack Developer 👨‍💻
          </div>
          <a class="popup-close" onClick={close}>&times;</a>
        </div>
      </div>

      <div id="userName">
        Prabhat Patel
      </div>

      <div id="links">
        <a class="link" href="https://github.com/i-m-prabhat" target="_blank" rel="noreferrer">
          <i class="fab fa-github">&nbsp;</i>Github
        </a>
        <a class="link" href="https://www.linkedin.com/in/devprabhat" target="_blank" rel="noreferrer">
          <i class="fab fa-linkedin">&nbsp;</i>Linkedin
        </a>
        <a class="link" href="https://leetcode.com/i-m-prabhat" target="_blank" rel="noreferrer">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="M13.483 0a1.374 1.374 0 0 0-.961.438L7.116 6.226l-3.854 4.126a5.266 5.266 0 0 0-1.209 2.104a5.35 5.35 0 0 0-.125.513a5.527 5.527 0 0 0 .062 2.362a5.83 5.83 0 0 0 .349 1.017a5.938 5.938 0 0 0 1.271 1.818l4.277 4.193l.039.038c2.248 2.165 5.852 2.133 8.063-.074l2.396-2.392c.54-.54.54-1.414.003-1.955a1.378 1.378 0 0 0-1.951-.003l-2.396 2.392a3.021 3.021 0 0 1-4.205.038l-.02-.019l-4.276-4.193c-.652-.64-.972-1.469-.948-2.263a2.68 2.68 0 0 1 .066-.523a2.545 2.545 0 0 1 .619-1.164L9.13 8.114c1.058-1.134 3.204-1.27 4.43-.278l3.501 2.831c.593.48 1.461.387 1.94-.207a1.384 1.384 0 0 0-.207-1.943l-3.5-2.831c-.8-.647-1.766-1.045-2.774-1.202l2.015-2.158A1.384 1.384 0 0 0 13.483 0zm-2.866 12.815a1.38 1.38 0 0 0-1.38 1.382a1.38 1.38 0 0 0 1.38 1.382H20.79a1.38 1.38 0 0 0 1.38-1.382a1.38 1.38 0 0 0-1.38-1.382z" /></svg> LeetCode
        </a>
        {/* <a class="link" href="https://www.facebook.com/" target="_blank" rel="noreferrer">
        <i class="fab fa-facebook">&nbsp;</i>Facebook
      </a> */}
        <a class="link" href="https://www.instagram.com/i_m_prabhat__/" target="_blank" rel="noreferrer">
          <i class="fab fa-instagram">&nbsp;</i>Instagram
        </a>
        <a class="link" href="https://twitter.com/i_m_prabhat__" target="_blank" rel="noreferrer">
          <i class="fab fa-twitter">&nbsp;</i>Twitter
        </a>



        <a class="link" href="https://www.youtube.com/@digitaljagran" target="_blank" rel="noreferrer">
          <i class="fab fa-youtube">&nbsp;</i>YouTube
        </a>
      </div>

      <div id="hashtag">
        ❤
        ❤
        ❤
        ❤
        ❤
      </div>
    </>
  );
}

export default App;
